import React, { useContext } from "react";
import {useTranslation} from "react-i18next";
import Barchart, {BarData} from "../../Charts/Barchart";
import '../MarketClusteringStyles.css'
import styled from "styled-components";
import { GlobalDataContext } from "../../../contexts/GlobalDataContext";
import { RegionSelectedContext } from "../../../contexts/RegionSelectedContext";
import LatamConcentrationRecord from "../../../models/LatamConcentrationRecord";
import Branch from "../../../interfaces/Branch";
import SimpleBarchart, { SimpleBarData } from "../../Charts/SimpleBarchart";

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  & .marketDetailsGoBack {
    font-family: MapfreText-ExtraBold;
    cursor: pointer;
    margin-bottom: 74px;

    &::after {
      display: inline-block;
      content: '';
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-right: 8px solid white;
      margin-left: 13px;
      height: 0px;
    }
  }
`;


const SquareColor = styled.div`
    height: 16px;
    width: 16px;
    margin-right: 10px;

    &.white {
      background-color: #FFFFFF;
    }

    &.black {
      background-color: #161615;
    }

    &.red {
      background-color: #CC0000
    }
`;

const PeriodYearComponent: React.FC = () => {
    const {t} = useTranslation();
    // @ts-ignore
    const { yearSelected } = useContext(RegionSelectedContext);

    return (
        <div className={'detailChartMarginBottom40 periodYearContainer'}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <SquareColor className='white' />
                <div>{ t('latamMarketConcentration.thirdChartLegend1', { yearStart: yearSelected.year - 10, yearEnd: yearSelected.year - 1 }) }</div>
            </div>

            <div style={{display: 'flex', flexDirection: 'row'}}>
                <SquareColor className='black' />
                <div>{ t('latamMarketConcentration.thirdChartLegend2', { year: yearSelected.year }) }</div>
            </div>

            <div style={{display: 'flex', flexDirection: 'row'}}>
                <SquareColor className='red' />
                <div>{ t('latamMarketConcentration.thirdChartLegend3', { yearStart: yearSelected.year - 10, yearEnd: yearSelected.year })}</div>
            </div>
        </div>
    )
};

const MarketClusteringDetailComponent: React.FC<{closeDetails: () => void}> = ({closeDetails}) => {
    const { t } = useTranslation();
    // @ts-ignore
    const { latamConcentrationRecords, reaseguroConcentrationRecords } = useContext(GlobalDataContext);
    // @ts-ignore
    const { yearSelected, regionSelected } = useContext(RegionSelectedContext);

    const records =
      (regionSelected === "latam" ? latamConcentrationRecords : reaseguroConcentrationRecords)
        .filter((x: LatamConcentrationRecord) => x.branch === Branch.TOTAL)
        .filter((x: LatamConcentrationRecord) => x.year === yearSelected.year && x.niiff === yearSelected.niiff);

    const simpleBars: SimpleBarData[] =
      records
        .sort((r1: LatamConcentrationRecord, r2: LatamConcentrationRecord) => r2.herfindahl_cont_year - r1.herfindahl_cont_year)
        .map((x: LatamConcentrationRecord) => ({ 'group': x.company_group, 'value': x.herfindahl_cont_year }));

    const bars: BarData[] =
      records
        .sort((r1: LatamConcentrationRecord, r2: LatamConcentrationRecord) => r2.herfindahl_var_last_10_years - r1.herfindahl_var_last_10_years)
        .map((x: LatamConcentrationRecord) => {
          return {
            group: x.company_group,
            bars: [x.herfindahl_var_last_10_years_last_year, x.herfindahl_var_last_year],
            point: x.herfindahl_var_last_10_years
          };
        });

    return (
        <Content>
            <div onClick={closeDetails} className={'marketDetailsGoBack'}>
                { t('goBack') }
            </div>
            <div className={'marketCLusterDetailContainer'}>
                <div className={'marketClusterDetailLeft'}>
                    <h3 className={'detailChartTitle'}>{ t('latamMarketConcentration.secondChartTitle', { year: yearSelected.year }) } </h3>
                    <div className={'detailChartSubTitle detailChartMarginBottom40'}>{ t('latamMarketConcentration.secondChartSubtitle', { year: yearSelected.year }) } </div>
                    <SimpleBarchart bars={ simpleBars } isDark={ false } />
                </div>
                <div className={'marketClusterDetailRight'}>
                    <h3 className={'detailChartTitle'}>{ t('latamMarketConcentration.thirdChartTitle', { yearStart: yearSelected.year - 1, yearEnd: yearSelected.year }) } </h3>

                    <PeriodYearComponent />
                    <Barchart
                      bars={ bars }
                      isDark={ false }
                      barColors={ ['#FFFFFF', '#161615'] }
                      formatVerticalTicks={ (n) => `${Math.round(n * 100)}%` }
                    />
                </div>
            </div>

        </Content>
    )
};

export default MarketClusteringDetailComponent;
